import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getChargeInfo,
  createCharge,
  cancelCharge,
  getWebCheckChargeInfo,
  createWebCheckCharge,
  cancelWebCheckCharge,
} from "api/payments";
import { queryKeys } from "./queryKeys";
import { toast } from "utils/toast";
import { CancelChargePayload, CreateChargePayload } from "js/pages/Payments/types";

export const useGetChargeInfo = (
  resourceType: string,
  resourceId: string,
  enabled: boolean = true,
  refetchInterval: number | false = false,
) => {
  return useQuery({
    queryKey: queryKeys.payments.chargeInfo(resourceType, resourceId),
    queryFn: () =>
      resourceType === "web-check"
        ? getWebCheckChargeInfo(resourceId)
        : getChargeInfo(resourceType, resourceId),
    enabled: !!resourceType && !!resourceId && enabled,
    refetchInterval,
  });
};

export const useCreateCharge = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateChargePayload) =>
      payload.resource_type === "web-check"
        ? createWebCheckCharge(payload.resource_id, payload.method)
        : createCharge(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.payments.chargeInfo(
          variables.resource_type,
          variables.resource_id,
        ),
      });
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || "Error al crear el cargo";
      toast.error(message);
    },
  });
};

export const useCancelCharge = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CancelChargePayload) =>
      payload.resource_type === "web-check"
        ? cancelWebCheckCharge(payload.resource_id)
        : cancelCharge(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.payments.chargeInfo(
          variables.resource_type,
          variables.resource_id,
        ),
      });
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || "Error al cancelar el cargo";
      toast.error(message);
    },
  });
};
